import React from 'react';
import Box from '../Box/Box';

import ToastIcon from './ToastIcon';
import ToastClose from './ToastClose';

import TToastBase from './@types/TToastBase';

const name = 'Toast';

const ToastBase = ({ signal, children, icon, onClose, ...rest }: TToastBase) => (
  <Box as="div" {...rest} name={name} modifiers={signal}>
    {icon && <ToastIcon icon={icon} />}
    <Box as="div" parent={name} name="body">
      {children}
    </Box>
    {onClose && <ToastClose onClose={onClose} />}
  </Box>
);

export default ToastBase;
